(() => {
  const section = document.querySelector('.main-product[data-product-section]');
  if (!section) return;

  let familyContext = {};
  try {
    familyContext = JSON.parse(section.querySelector('[data-kabo-family-context]')?.textContent || '{}');
  } catch (_) {
    return;
  }

  if (familyContext.family !== 'steamclean') return;

  const productKey = String(familyContext.productKey || '');
  const isSteamStandard = productKey === 'steamclean-standard';
  const isSteamPro = productKey === 'steamclean-pro';
  if (!isSteamStandard && !isSteamPro) return;

  const root = (window.KABO && window.KABO.root) || '/';
  const currency = (window.KABO && window.KABO.currency) || 'EUR';
  const freeShippingThreshold = Math.max(0, Number((window.KABO && window.KABO.freeShippingThreshold) || 5500));
  const familyName = String(familyContext.cardName || 'KABO SteamClean').trim();

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency
      }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `${((Number(cents) || 0) / 100).toFixed(2)} €`;
    }
  };
  const moneyPlain = (cents) => money(cents).replace(/\s?€/g, '').trim().replace(/,00$/, '') + ' €';

  const subtitleNodes = Array.from(section.querySelectorAll('[data-kabo-product-subtitle]'));
  const subtitleSource = subtitleNodes[0];
  const subtitleForModel = (model) => {
    if (!subtitleSource) return '';
    return model === 'standard'
      ? (subtitleSource.dataset.kaboSubtitleStandard || subtitleSource.dataset.kaboSubtitleDefault || '')
      : (subtitleSource.dataset.kaboSubtitlePro || subtitleSource.dataset.kaboSubtitleDefault || '');
  };
  const syncSubtitle = (model) => {
    const text = subtitleForModel(model);
    if (!text) return;
    subtitleNodes.forEach((node) => { node.textContent = text; });
  };

  const normalizeFamilyTitle = () => {
    if (!familyName) return;
    section.querySelectorAll('.product-title--brand, .product-lightbox__title').forEach((title) => {
      title.textContent = familyName;
    });
  };

  const productPath = (handle) => `${root}products/${handle}`.replace(/\/+/g, '/');
  const productJsonUrl = (path) => `${path.replace(/\/$/, '')}.js`;
  const fetchProductByHandle = async (handle) => {
    if (!handle) return null;
    const path = productPath(handle);
    try {
      const response = await fetch(productJsonUrl(path), { headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const candidate = await response.json();
      candidate._kaboPath = path;
      return candidate;
    } catch (_) {
      return null;
    }
  };

  const firstAvailableVariant = (product) => product?.variants?.find((variant) => variant.available) || product?.variants?.[0] || null;

  normalizeFamilyTitle();

  if (isSteamStandard) {
    syncSubtitle('standard');
    const parentHandle = String(familyContext.canonicalParentHandle || '').trim();
    if (!parentHandle || window.Shopify?.designMode) return;
    const target = new URL(productPath(parentHandle), window.location.origin);
    target.searchParams.set('model', 'standard');
    window.location.replace(target.toString());
    return;
  }

  syncSubtitle('pro');

  (async () => {
    const standardHandle = String(familyContext.standardProductHandle || '').trim();
    const standardProduct = await fetchProductByHandle(standardHandle);
    if (!standardProduct) return;

    const standardVariant = firstAvailableVariant(standardProduct);
    if (!standardVariant) return;

    let currentVariants = [];
    try {
      currentVariants = JSON.parse(section.querySelector('[data-product-variants]')?.textContent || '[]');
    } catch (_) {
      return;
    }
    if (!currentVariants.length) return;

    const form = section.querySelector('[data-kabo-product-form]');
    const idInput = form?.querySelector('[data-variant-id], input[name="id"]');
    const quantityRow = form?.querySelector('.quantity-row');
    if (!form || !idInput || !quantityRow) return;

    const currentVariantId = String(idInput.value || '');
    let proVariant = currentVariants.find((variant) => String(variant.id) === currentVariantId)
      || currentVariants.find((variant) => variant.available)
      || currentVariants[0];
    if (!proVariant) return;

    const prices = Array.from(section.querySelectorAll('[data-product-price]'));
    const compares = Array.from(section.querySelectorAll('[data-product-compare]'));
    const stickyPrice = section.querySelector('[data-sticky-product-price]');
    const submit = form.querySelector('[data-product-submit]');
    const submitLabel = form.querySelector('[data-product-submit-label]');
    const stickySubmit = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-add-label]');
    const optionArea = form.querySelector('.product-options');
    const deliveryNodes = Array.from(section.querySelectorAll('[data-product-delivery-time]'));
    const proDelivery = deliveryNodes[0]?.textContent?.trim() || '5–12 Werktage';
    const descriptionNodes = Array.from(section.querySelectorAll('[data-steam-model-description]'));

    let standardDelivery = proDelivery;
    if (standardProduct._kaboPath) {
      try {
        const response = await fetch(standardProduct._kaboPath, { headers: { Accept: 'text/html' } });
        if (response.ok) {
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const delivery = doc.querySelector('[data-product-delivery-time]')?.textContent?.trim();
          if (delivery) standardDelivery = delivery;
        }
      } catch (_) {}
    }

    const gallery = section.querySelector('[data-product-gallery]');
    const slides = gallery ? Array.from(gallery.querySelectorAll('[data-gallery-slide]')) : [];
    const proSlides = slides.map((slide) => ({
      html: slide.innerHTML,
      hidden: slide.hidden,
      mediaId: slide.getAttribute('data-media-id'),
      variantOnly: slide.hasAttribute('data-variant-only-media'),
      curatedHidden: slide.hasAttribute('data-curated-hidden-media')
    }));
    const standardImages = Array.isArray(standardProduct.images) ? standardProduct.images : [];

    const showStandardGallery = () => {
      if (!gallery || !slides.length || !standardImages.length) return;
      slides.forEach((slide, index) => {
        const source = standardImages[index];
        slide.removeAttribute('data-variant-only-media');
        slide.removeAttribute('data-curated-hidden-media');
        if (!source) {
          slide.hidden = true;
          return;
        }
        slide.hidden = false;
        slide.setAttribute('data-media-id', `steamclean-standard-${index}`);
        slide.innerHTML = `<img src="${String(source).replace(/"/g, '&quot;')}" loading="${index === 0 ? 'eager' : 'lazy'}" alt="${familyName} Standard – Produktansicht ${index + 1}">`;
      });
      gallery.scrollLeft = 0;
    };

    const showProGallery = () => {
      if (!gallery || !slides.length) return;
      slides.forEach((slide, index) => {
        const state = proSlides[index];
        if (!state) return;
        slide.innerHTML = state.html;
        slide.hidden = state.hidden;
        if (state.mediaId === null) slide.removeAttribute('data-media-id');
        else slide.setAttribute('data-media-id', state.mediaId);
        if (state.variantOnly) slide.setAttribute('data-variant-only-media', '');
        else slide.removeAttribute('data-variant-only-media');
        if (state.curatedHidden) slide.setAttribute('data-curated-hidden-media', '');
        else slide.removeAttribute('data-curated-hidden-media');
      });
      gallery.scrollLeft = 0;
    };

    const updateShippingNote = (amount) => {
      const free = Number(amount) >= freeShippingThreshold;
      section.querySelectorAll('[data-product-shipping-note]').forEach((note) => {
        note.querySelectorAll('[data-shipping-paid]').forEach((copy) => { copy.hidden = free; });
        note.querySelectorAll('[data-shipping-free]').forEach((copy) => { copy.hidden = !free; });
      });
    };

    const syncDescription = (model) => {
      descriptionNodes.forEach((node) => {
        node.hidden = node.dataset.steamModelDescription !== model;
      });
    };

    const updateVariantUi = (variant, model) => {
      idInput.value = variant.id;
      prices.forEach((price) => { price.textContent = moneyPlain(variant.price); });
      if (stickyPrice) stickyPrice.textContent = moneyPlain(variant.price);
      compares.forEach((compare) => {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.textContent = moneyPlain(variant.compare_at_price);
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      });
      if (submit) submit.disabled = !variant.available;
      if (submitLabel) submitLabel.textContent = variant.available ? 'In den Warenkorb' : 'Nicht verfügbar';
      if (stickySubmit) stickySubmit.disabled = !variant.available;
      if (stickyLabel) stickyLabel.textContent = variant.available ? 'In den Warenkorb' : 'Nicht verfügbar';
      updateShippingNote(variant.price);
      deliveryNodes.forEach((node) => { node.textContent = model === 'standard' ? standardDelivery : proDelivery; });
      if (optionArea) optionArea.hidden = model === 'standard';
      syncSubtitle(model);
      syncDescription(model);
      if (model === 'standard') showStandardGallery();
      else showProGallery();
    };

    const picker = document.createElement('fieldset');
    picker.className = 'grill-model-picker steam-model-picker';
    picker.setAttribute('data-steam-model-picker', '');
    picker.innerHTML = `
      <legend class="field-label">Ausführung <span data-steam-model-current>Pro</span></legend>
      <div class="grill-model-picker__options">
        <div class="grill-model-picker__option">
          <input class="variant-pill__input visually-hidden" type="radio" id="SteamModel-standard" name="steam-model" value="standard" data-steam-model-input${standardVariant.available ? '' : ' disabled'}>
          <label class="grill-model-picker__card" for="SteamModel-standard">
            <span class="grill-model-picker__details">
              <span class="grill-model-picker__title">Standard</span>
              <span class="grill-model-picker__description">Kompakt · 1.000 W · 280 ml</span>
            </span>
            <strong class="grill-model-picker__price">${moneyPlain(standardVariant.price)}</strong>
          </label>
        </div>
        <div class="grill-model-picker__option">
          <input class="variant-pill__input visually-hidden" type="radio" id="SteamModel-pro" name="steam-model" value="pro" data-steam-model-input checked${proVariant.available ? '' : ' disabled'}>
          <label class="grill-model-picker__card" for="SteamModel-pro">
            <span class="grill-model-picker__details">
              <span class="grill-model-picker__title">Pro</span>
              <span class="grill-model-picker__description">Basisgerät · flexibler Schlauch · mehr Zubehör</span>
            </span>
            <strong class="grill-model-picker__price">${moneyPlain(proVariant.price)}</strong>
          </label>
        </div>
      </div>`;
    quantityRow.before(picker);

    const modelLabel = picker.querySelector('[data-steam-model-current]');
    const modelInputs = Array.from(picker.querySelectorAll('[data-steam-model-input]'));

    const applyModel = (model, updateUrl = true) => {
      const input = modelInputs.find((candidate) => candidate.value === model && !candidate.disabled);
      if (!input) return;
      modelInputs.forEach((candidate) => { candidate.checked = candidate === input; });
      if (modelLabel) modelLabel.textContent = model === 'standard' ? 'Standard' : 'Pro';
      updateVariantUi(model === 'standard' ? standardVariant : proVariant, model);
      if (updateUrl && history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('model', model);
        if (model === 'pro') url.searchParams.set('variant', proVariant.id);
        else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
      }
    };

    form.querySelectorAll('[data-product-option]').forEach((input) => {
      input.addEventListener('change', () => {
        window.setTimeout(() => {
          const selectedId = String(idInput.value || '');
          const selectedVariant = currentVariants.find((variant) => String(variant.id) === selectedId);
          if (selectedVariant) proVariant = selectedVariant;
        }, 0);
      });
    });

    modelInputs.forEach((input) => input.addEventListener('change', () => applyModel(input.value)));
    const modelParameters = new URL(window.location.href).searchParams;
    const requestedModel = modelParameters.get('model');
    const defaultModel = String(familyContext.entryModel || 'standard');
    const initialModel = requestedModel === 'standard' || requestedModel === 'pro'
      ? requestedModel
      : (modelParameters.has('variant') || !standardVariant.available ? 'pro' : defaultModel);
    applyModel(initialModel, false);
  })();
})();
